module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-video-off-9ef2d100.svg";